import { Component, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppointmentRequest } from '../../shared/models/appointment-request.model';
import { AppointmentRequestsService } from './appointment-requests.service';
import { Group } from '../../shared/models/group.model';
import { AppState } from '../../app.state';
import * as fromAppointmentRequests from './appointment-requests.reducer';

@Component({
  selector: 'appointment-request-cancel',
  template: require('./appointment-request-cancel.component.html'),
})

export class AppointmentRequestCancelComponent {
  appointmentRequest: AppointmentRequest;
  group: Group;

  constructor(
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
    public AppointmentRequestsService: AppointmentRequestsService,
    private store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.group = this.$ngRedux.getState().group;
    this.store.select(fromAppointmentRequests.getSelectedAppointmentRequest)
      .subscribe((appointmentRequest) => {
        this.appointmentRequest = appointmentRequest;
      });
  }

  goToHome() {
    this.$state.go('patients.id.home');
  }

  cancelRequest() {
    this.AppointmentRequestsService.cancel(this.group.id, this.$state.params.requestId)
      .subscribe(
        (data) => {
          if (data) {
            this.$state.go('patients.id.home');
          }
        },
        err => undefined,
      );
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/appointment-request-cancel.component.ts